/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Property} from './property'  ;

export class EventData {
  id: number;
  property: Property;
  value: string;
  object_value: any;
}
